import { Component, h, Prop, State } from "@stencil/core";
import "../../utils/i18n";
import "../../utils/global";
import { getBrandFromURL, getConfigurationValues, getEnvironment } from "../../sharedNavService/helperFunctions";
import { loadingStateData } from "../../sharedNavService/mocks/loadingStateData";

@Component({
    tag: "shared-nav-app-root",
    styleUrls: {
        default: "../../assets/shared-nav-chevrolet.scss",
        buick: "../../assets/shared-nav-buick.scss",
        cadillac: "../../assets/shared-nav-cadillac.scss",
        chevrolet: "../../assets/shared-nav-chevrolet.scss",
        gmc: "../../assets/shared-nav-gmc.scss"
    },
    shadow: true
})

/**
 * shared-nav-app-root is the base component for the whole application.
 * shared-nav-app-root does take a param of "brand".
 * @param {string} brand - a string passed to shared-nav-app-root that allows for different styling to be rendered
 * @param {boolean} sso - whether or not the nav should attach isSSO to the urls
 * @param {Function} clickHandler - If passed in the Nav will use it insteaf of the default href Functionality
 */
export class SharedNavAppRoot {
    @Prop({ mutable: true }) brand: string;
    @Prop() visible: boolean;
    @Prop() sso: boolean;
    @Prop() clickHandler: Function;

    @State() mobileBreakpoint: number = 992;
    @State() navBarData: {};
    @State() hoveringState: Array<boolean> = [];
    @State() isMobile: boolean = false;
    @State() currentLocation: Array<string> = [];
    @State() localHost: boolean = window.location.hostname.includes("localhost");
    @State() loading: boolean = true;
    @State() environment: boolean = getEnvironment() === 2;

    /**
     * This will run before the nav loads to get all the information for the individual components
     */
    async connectedCallback() {
        this.loading = true;
        if (this.visible) {
            this.brand = getBrandFromURL();
            const vaultConfigs = await getConfigurationValues(this.brand, this.localHost, this.sso);
            this.navBarData = vaultConfigs.sharedNavData || [];

            Object.keys(this.navBarData).map(() => {
                this.hoveringState.push(false);
            });

            this.mobileBreakpoint = vaultConfigs.mobileBreakpoint;
        }

        this.isMobile = window.innerWidth < this.mobileBreakpoint;
        window.addEventListener("resize", this.handleResize);
        this.loading = false;
    }

    /**
     * This will handle the logic if the window that the nav is in changes width
     */
    private handleResize = () => {
        this.isMobile = window.innerWidth < this.mobileBreakpoint;
    };

    render() {
        // If the nav has the visible parameter set to true it will render the nav else render null
        if (this.visible) {
            if (!this.loading && this.isMobile) {
                return (
                    <div class={"usfsn-mobile-root-styles"}>
                        <shared-nav-mobile-view
                            id={"usfsn-mobile-view"}
                            class="usfsn-mobile-view-styles"
                            navBarData={this.navBarData}
                            brand={this.brand}
                            clickHandler={this.clickHandler}
                        ></shared-nav-mobile-view>
                    </div>
                );
            } else if (!this.loading && !this.isMobile) {
                return (
                    <shared-nav-desktop-view
                        id={"usfsn-desktop-view"}
                        navBarData={this.navBarData}
                        toggledCategoriesStateProp={this.hoveringState}
                        class={this.environment ? "usfsn-brand-text-size" : "usfsn-standard-text-size"}
                        clickHandler={this.clickHandler}
                    ></shared-nav-desktop-view>
                );
            } else {
                if (window.innerWidth < 991) {
                    return (
                        <div class={"usfsn-mobile-root-styles"}>
                            <shared-nav-mobile-view
                                id={"usfsn-mobile-view"}
                                class="usfsn-mobile-view-styles"
                                navBarData={loadingStateData()}
                                brand={this.brand}
                                clickHandler={this.clickHandler}
                            ></shared-nav-mobile-view>
                        </div>
                    );
                } else {
                    return (
                        <shared-nav-desktop-view
                            id={"usfsn-desktop-view"}
                            navBarData={loadingStateData()}
                            toggledCategoriesStateProp={this.hoveringState}
                            class={this.environment ? "usfsn-brand-text-size" : "usfsn-standard-text-size"}
                            clickHandler={this.clickHandler}
                        ></shared-nav-desktop-view>
                    );
                }
            }
        } else {
            return null;
        }
    }
}
